import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import InitServiceWorker from './ServiceWorker';

try{
  InitServiceWorker();
}catch(ex){
  console.log('Error Initializing service Worker', ex);
}


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
